// src/components/dashboard/pages/DeliveryScheduleList/DeliveryScheduleList.jsx
import React from 'react';
import i18n from '../../../../i18n';
import { SideBar } from '../../sidebar';
import { DeliveryScheduleTable } from './components/DeliveryScheduleTable'; // Fixed import
import NoData from '../../../common/NoData';
import { TableSkeleton } from '../../../common/skelton/TableSkelton';
import StatusTabs from '../../../common/StatusTab';
import HeaderBanner from '../../../common/HeaderBanner';
import { getLoggedUser } from '../../../../state/user';
import { MOCK_DELIVERY_SCHEDULE_API_RESPONSE } from './services/DeliveryScheduleDataGenerator'; // Added import
import { getDeliveryScheduleList } from './services/DeliveryScheduleService';

export class DeliveryScheduleList extends React.Component {
    constructor() {
        super();
        this.state = {
            search: {
                group: '',
                auction: '',
                status: '',
                bidder: null,
            },
            siteVisitStatus: 'all',
            input: {},
            groups: [],
            auctions: [],
            customers: [],
            siteVisits: [],
            selectedUser: {},
            showUserPopUp: false,
            statusData: [
                { key: 'all', label: 'All', count: 0 },
                { key: 'scheduled', label: 'Scheduled', count: 0 },
                { key: 'in_transit', label: 'In Transit', count: 0 },
                { key: 'completed', label: 'Completed', count: 0 },
                { key: 'delayed', label: 'Delayed', count: 0 },
            ],
            is_loading: false,
            limit: 15,
            page: 1,
            rejectNote: null,
            rejectNoteError: null,
            hideSidebar: false,
            showModal: false
        };

    }

    componentDidMount() {
        window.scrollTo(0, 0);
        const params = new URLSearchParams(window.location.search);
        const search = {
            group: params.get('group') || '',
            auction: params.get('auction') || '',
            status: params.get('status') || '',
            bidder: params.get('bidder') || null,
        };
        const siteVisitStatus = params.get('siteVisitStatus');
        const page = parseInt(params.get('page')) || 1;
        const limit = parseInt(params.get('limit')) || 15;

        this.setState({ search, siteVisitStatus, page, limit }, () => {
            this.getSiteVisits();
        });
    }

    updateUrlQuery(q) {
        const queryString = new URLSearchParams(
            Object.fromEntries(Object.entries(q).filter(([_, v]) => v !== '' && v !== null))
        ).toString();
        window.history.replaceState(null, '', `${window.location.pathname}?${queryString}`);
    }

    async getSiteVisits() {
        this.setState({ is_loading: true });
        let { limit, page, siteVisitStatus } = this.state;

        // Use mock data for development

        //  const mockResponse =   getDeliveryScheduleList(page, limit, {
        //     status: siteVisitStatus !== 'all' ? siteVisitStatus : null,
        // })
        const mockResponse = MOCK_DELIVERY_SCHEDULE_API_RESPONSE(page, limit, {
            status: siteVisitStatus !== 'all' ? siteVisitStatus : null,
        });

        if (mockResponse && mockResponse.status === true) {
            let siteVisits = mockResponse.data || [];
            let pagination = mockResponse.pagination;

            let { total, scheduled, in_transit, completed, delayed } = mockResponse.meta;

            this.setState({
                siteVisits: siteVisits,
                total: pagination?.total || siteVisits.length,
                statusData: [
                    { key: 'all', label: 'All', count: total || 0 }, 
                    { key: 'scheduled', label: 'Scheduled', count: scheduled || 0 },
                    { key: 'in_transit', label: 'In Transit', count: in_transit || 0 },
                    { key: 'completed', label: 'Completed', count: completed || 0 },
                    { key: 'delayed', label: 'Delayed', count: delayed || 0 },
                ],
                is_loading: false,
            });
        } else {
            console.error('Failed to fetch delivery schedules');
            this.setState({
                siteVisits: [],
                is_loading: false
            });
        }
    }

    handleTabChange = (key) => {
        this.setState({ siteVisitStatus: key }, () => {
            this.getSiteVisits();
        });
    };

    onChangePage = (page) => {
        this.setState({ page: page }, () => {
            this.getSiteVisits();
        });
    };

    onChangeRowsPerPage = (limit) => {
        this.setState({ limit: limit, page: 1 }, () => {
            this.getSiteVisits();
        });
    };

    render() {
        const user = getLoggedUser();

        return (
            <React.Fragment>
                <HeaderBanner
                    title={i18n.t('delivery_schedule_list')}
                    subtitle={i18n.t('manage_delivery_schedule_list')}
                />
                <section className="mt-5">
                    <div className="container">
                        <div className="row">
                            <div className="col-xl-3 col-lg-12 col-md-12">
                                {!this.state.hideSidebar && <SideBar />}
                            </div>
                            <div
                                className={
                                    this.state.hideSidebar
                                        ? 'col-xl-12 col-lg-12 col-md-12'
                                        : 'col-xl-9 col-lg-12 col-md-12'
                                }
                            >
                                <div className="card">
                                    <div className="card-header">
                                        <div className="expand-dashboard">
                                            <span
                                                style={{ fontSize: '1rem', marginRight: '0.5rem', cursor: 'pointer' }}
                                                onClick={() => {
                                                    this.setState({
                                                        hideSidebar: !this.state.hideSidebar,
                                                    });
                                                }}
                                            >
                                                {this.state.hideSidebar && <i className="icon-size-actual"></i>}
                                                {!this.state.hideSidebar && <i className="icon-size-fullscreen"></i>}
                                            </span>
                                        </div>
                                    </div>
                                    <div className="card-body">
                                        <StatusTabs
                                            tabs={this.state.statusData}
                                            onTabChange={this.handleTabChange}
                                            selected={this.state.siteVisitStatus}
                                        />

                                        <div className="Data-Listing">
                                            {this.state.is_loading ? (
                                                <TableSkeleton columns={8} rows={10} />
                                            ) : this.state.siteVisits.length ? (
                                                <DeliveryScheduleTable
                                                    siteVisits={this.state.siteVisits}
                                                    isLoading={this.state.is_loading}
                                                    currentPage={this.state.page}
                                                    limit={this.state.limit}
                                                    total={this.state.total}
                                                    onChangePage={this.onChangePage}
                                                    onChangeRowsPerPage={this.onChangeRowsPerPage}
                                                    showUserInfo={(user) => {
                                                        this.setState({
                                                            selectedUser: user,
                                                            showUserPopUp: true,
                                                        });
                                                    }}
                                                    userRole={user?.role}
                                                    history={this.props.history}
                                                />
                                            ) : (
                                                <NoData
                                                    message="No delivery schedules available"
                                                    actionText="Refresh"
                                                    onAction={this.getSiteVisits.bind(this)}
                                                />
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </React.Fragment>
        );
    }
}

export default DeliveryScheduleList;